import { ChangeDetectionStrategy, Component, output, viewChild } from '@angular/core';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { DrawerDirective } from '../../drawer/drawer.directive';
import { ButtonComponent } from '../../button/button.component';
import { IconComponent } from '../../icon/icon.component';

@Component({
	selector: 'skl-filter-drawer',
	template: `
		<ng-template sklDrawer #drawer="sklDrawer">
			<header class="drawer-header">
				<skl-button 
					data-kind="icon-only" 
					typeName="transparent" 
					(click)="close()">
					<skl-icon size="24px" name="arrow-r-right" />
				</skl-button>
				<h2>{{ 'ui.filter-drawer.title' | translate }}</h2>
			</header>

			<section class="drawer-content">
				<ng-content />
			</section>

			<footer class="drawer-footer">
				<skl-button (click)="resetAll.emit()">
					<skl-icon name="arrow-reset-filled" size="20px" />
					{{ 'ui.filter-drawer.restore-default' | translate }}
				</skl-button>
			</footer>
		</ng-template>
	`,
	styles: `
		:host {
			display: contents;

			.drawer-header {
				display: flex;
				align-items: center;
				gap: var(--gutter-small);
				padding: var(--gutter-medium) var(--gutter-big);
				border-bottom: 1px solid var(--line-1-color);
				
				h2 {
					margin: 0;
					font-size: 1.25rem;
					font-weight: 600;
					color: var(--text-color);
				}
			}

			.drawer-content {
				padding: var(--gutter-big);
				display: flex;
				flex-direction: column;
				gap: 1rem;
				flex: 1;
				overflow-y: auto;
			}

			.drawer-footer {
				display: flex;
				padding: var(--gutter-medium) var(--gutter-big);
				border-top: 1px solid var(--line-1-color);
			}
		}
	`,
	imports: [TranslatePipe, DrawerDirective, ButtonComponent, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDrawerComponent {
	public readonly resetAll = output();

	public readonly drawer = viewChild(DrawerDirective);

	public open() {
		this.drawer()?.open();
	}

	public close() {
		this.drawer()?.close();
	}
}
